export const Arr_BasicInfo = [
  //-------------------------------------------------------------------------
  // BasicInfo
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Student first name",
    name: "First_Name",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Student last name",
    name: "Last_Name",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Nationality",
    name: "Nationality",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "PhoneNumberFieldForObjectState",
    label: "Number",
    name: "Number",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p style={{ textAlign: "left" }}>
        Please provide attendee information only
        <br></br>Please choose your area code by selecting the image below
      </p>
    ),
  },
  {
    Page: "BasicInfo",
    TextField: "DateFieldForObjectState",
    label: "Date of birth",
    name: "DOB",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "School name",
    name: "uncleanSchool",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Country of School",
    name: "uncleanSchoolCountry",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "City of School",
    name: "uncleanSchoolCity",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //Address

  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Country",
    name: "Country",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "City",
    name: "City",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Student's home address",
    name: "Student_home_address",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Postcode/ zipcode",
    name: "Postcode_Zipcode",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  //Pronouns
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Student preferred first name (optional)",
    name: "Student_preferred_first_name",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    SpecialCondition: "Optional",
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "Sex at birth",
    name: "Gender",
    selectValues: ["F", "M"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "Student pronouns",
    name: "Student_pronouns",
    selectValues: [
      "She/ her/ hers",
      "He/ him/ his",
      "They/ them/ theirs",
      "Other",
    ],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the students pronouns",
    name: "Student_pronouns_specified",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Student_pronouns",
  },

  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student’s gender identity match their assigned sex at birth",
    name: "Student_gender_identity",
    selectValues: ["Yes", "No", "Prefer not to say"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "If no, please tell us the student’s gender identity",
    name: "Student_gender_identity_specified",
    selectValues: [
      "Transgender (female)",
      "Transgender (male)",
      "Non-binary",
      "Gender-fluid",
      "Prefer not to say",
    ],
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Student_gender_identity",
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student have any specific religious/ cultural/ spiritual views that InvestIN may need to accommodate during learning hours (approximately 10.30am-5.30pm)",
    name: "Student_specific_religious_views",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "If yes, please select from the below",
    name: "Student_specific_religious_views_specified",
    selectValues: [
      "Time and space for prayer",
      "Attend a local place of worship",
      "Other",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Student_specific_religious_views",
  },
  {
    Page: "BasicInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the specific students views",
    name: "Student_specific_religious_views_specified_other_specified",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Student_specific_religious_views_specified",
  },
  //Language questions
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student’s primary language of instruction at school English",
    name: "primary_language_is_english",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        All InvestIN experiences are taught in English. For students to fully
        engage in the content and activities, our minimum language requirement
        is level B2 (upper intermediate) or above. Students who cannot
        comfortably communicate in English may be removed
      </p>
    ),
  },
  {
    Page: "BasicInfo",
    TextField: "SelectFieldForObjectState",
    label: "If no, please indicate the student's English language level",
    name: "primary_language_is_english_level",
    selectValues: [
      "Native",
      "C2 (Advanced/Fluent)",
      "C1 (Advanced)",
      "B2 (Upper Intermediate)",
    ],
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "primary_language_is_english",
  },
];
